import * as React from "react";
import Admin from "./Admin";
import User from "./User";
import { Tab, Tabs } from "react-bootstrap";
import Card from "material-ui/Card";

function Administration(props) {
  return (
    <Tabs
      defaultActiveKey="admin"
      transition={false}
      id="noanim-tab-example"
      className="mb-3"
    >
      <Tab eventKey="admin" title="Admin">
        <Card
          variant="outlined"
          style={{ background: "#fff", padding: 16, minHeight: "80vh" }}
        >
          <Admin />
        </Card>
      </Tab>
      <Tab eventKey="user" title="User">
        <Card style={{ background: "#fff", padding: 16, minHeight: "80vh" }}>
          <User {...props} />
        </Card>
      </Tab>
    </Tabs>
  );
}

export default Administration;



// WEBPACK FOOTER //
// ./app/components/Administration/index.js